module.exports = __webpack_public_path__ + "assets/img/949b903a1ef4fe06a33a091ce31a7837.png";